var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermitHolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.2,
    height: 29.2,
    viewBox: "0 0 29.2 29.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "seguro-de-automovel",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.972,18.283,23.61,17.266c-5.2-5.2-4.9-5.094-5.315-5.2A14.279,14.279,0,0,0,21.2,2.942a.856.856,0,0,0-.874-.855A9.8,9.8,0,0,1,14.307.168a.856.856,0,0,0-1.02,0A9.8,9.8,0,0,1,7.263,2.092a.856.856,0,0,0-.874.855,14.3,14.3,0,0,0,2.864,9.086H6.085a.855.855,0,0,0-.763.468L2.954,17.162H2a2,2,0,0,0-2,2V22.54a3.14,3.14,0,0,0,3.137,3.137h.317a3.487,3.487,0,1,0,6.974,0h8.4a3.487,3.487,0,1,0,6.974,0h2.545a.855.855,0,0,0,.855-.855V21.285a3.119,3.119,0,0,0-2.228-3ZM8.12,3.786A11.546,11.546,0,0,0,13.8,1.9,11.534,11.534,0,0,0,19.47,3.781,11.982,11.982,0,0,1,16.5,11.533a9.652,9.652,0,0,1-2.709,2.1c-1.172-.579-5.348-3.106-5.671-9.844Zm.549,9.958H10.9a9.668,9.668,0,0,0,2.6,1.626.855.855,0,0,0,.6,0,9.785,9.785,0,0,0,2.567-1.624h1.053l3.38,3.418H8.669ZM6.94,27.489a1.777,1.777,0,1,1,1.777-1.777A1.779,1.779,0,0,1,6.94,27.489Zm15.372,0a1.777,1.777,0,1,1,1.777-1.777A1.779,1.779,0,0,1,22.313,27.489Zm3.017-3.523a3.485,3.485,0,0,0-6.034,0H9.958a3.485,3.485,0,0,0-6.034,0H3.137A1.427,1.427,0,0,1,1.711,22.54v-.184h.913a.855.855,0,1,0,0-1.711H1.711V19.158A.285.285,0,0,1,2,18.873H3.479a.855.855,0,0,0,.763-.468L6.61,13.744h.348v4.273a.855.855,0,0,0,.855.855h15.2l3.462,1.048a1.419,1.419,0,0,1,.818.644h-.889a.855.855,0,1,0,0,1.711h1.084v1.69H25.33Z",
    transform: "translate(0 0)",
    fill: "#2e3191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.3,93.941a.855.855,0,0,0,1.21,0l2.481-2.481a.855.855,0,0,0-1.21-1.21l-1.876,1.876-.564-.564a.855.855,0,0,0-1.21,1.21Z",
    transform: "translate(-187.54 -84.867)",
    fill: "#2e3191"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermitHolder);
export default __webpack_public_path__ + "static/media/permit-holder.04185570f463b3fb0887ecc65648720b.svg";
export { ForwardRef as ReactComponent };